import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-responsive-modal';
import lodash from 'lodash';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as EcoAllianceBadge } from '../../../images/Badges3.svg';
import { default as IndustryExpertsBadge } from '../../../images/Industry_Experts_Badge.svg';
import 'react-responsive-modal/styles.css';
import './IndustryExpertsBlogModal.scss';

const IndustryExpertsBlogModal = ({
  isOpen,
  onClose,
  blog,
  blogList
}) => {

  const [open, setOpen] = useState(isOpen);
  const [shownBlog, setShownBlog] = useState({});
  const modalContainerRef = useRef(null);
  const [column1, column2, column3] = lodash.chunk(blogList, 3);

  useEffect(() => {
    document.body.parentElement.style.overflow = 'hidden';
    return () => {
      document.body.parentElement.style.overflow = 'auto';
    }
  }, []);

  useEffect(() => {
    if (blog) setShownBlog(blog);
  }, [blog]);

  const onCloseModal = () => {
    onClose();
    setOpen(false);
  }

  const openNewBlog = tempBlog => {
    modalContainerRef.current.scrollIntoView({ behavior: "smooth" });
    setShownBlog(tempBlog)
  }

  return (
    <Modal open={open} onClose={onCloseModal} classNames={{ root: "industry-experts-reel-modal" }} >
      <div ref={modalContainerRef}>
        <div className="industry-experts-blog-modal-breadcrumb" role="button" tabIndex="0">
          <span className="industry-experts-blog-modal-breadcrumb-title">The Wrap {'>'}</span>
          <span className="industry-experts-blog-modal-breadcrumb-title">Inspo {'>'}</span>
          <span className="industry-experts-blog-modal-breadcrumb-subtitle">{shownBlog?.node?.title}</span>
        </div>
        <div className="industry-experts-blog-modal-container">
          <div className="industry-experts-blog-modal-left">
            <div className="industry-experts-blog-modal-image">
              <CommunityImg src={shownBlog?.node?.featureImage.file.url} alt="event" />
            </div>
          </div>
          <div className="industry-experts-blog-modal-right">
            <div className="blog-card-details">
              <div className="blog-card-details-date">
                <span className="blog-card-date-label">{shownBlog?.node?.createdAt}</span>
              </div>
              <div className="blog-card-details-header">
                <span className="blog-card-details-title">{shownBlog?.node?.title}</span>
              </div>
              <div className="industry-experts-modal-separator" />
              <div className="industry-experts-blog-modal-description">
                <pre>
                  {shownBlog?.node?.description}
                </pre>
              </div>
              <button className="read-story-btn" onClick={() => window.open(`${shownBlog?.node?.buttonLink}`, '_blank', 'noopener')}>{shownBlog?.node?.buttonLabel}</button>
              <div className="industry-experts-modal-separator" />

              <div className="industry-experts-modal-tags">
                {
                  (shownBlog?.node?.tags || []).map((eventTag, idx) => {
                    return <span key={`eventtag-${idx}`}>{eventTag.slug}</span>
                  })
                }
                {/* <span>{eventTypeTag}</span> */}
              </div>
              <div className="badges">
                <CommunityImg className="eco-alliance-badge" src={EcoAllianceBadge} alt="Eco Alliance Badge" />
                <CommunityImg className="industry-expert-badge" src={IndustryExpertsBadge} alt="Industry Experts Badge" />
              </div>
            </div>
          </div>
        </div>
        <div className="noissue__industry-experts__reel-section__blogs industry-experts-modal">
          <div className="column1">
            {
              (column1 || []).map((blog, idx) => {
                return <div key={`blog-${idx}`}
                  className="noissue__industry-experts__reel-section__blogs__item"
                  onKeyDown={() => openNewBlog(blog)}
                  onClick={() => openNewBlog(blog)}
                >
                  <CommunityImg
                    role="presentation"
                    src={blog.node?.featureImage.file.url} alt={blog.node.title} />
                  <span>
                    {blog.node.title}
                  </span>
                </div>
              })
            }

          </div>
          <div className="column2">
            {
              (column2 || []).map((blog, idx) => {
                return (
                  idx === 0 ? <div key={`blog-${idx}`} className="looking-for-highlights">
                    <div className="subheading">Looking for more </div>
                    <div className="heading">Highlights?</div>
                  </div> :
                    <div key={`blog-${idx}`}
                      className="noissue__industry-experts__reel-section__blogs__item"
                      onKeyDown={() => openNewBlog(blog)}
                      onClick={() => openNewBlog(blog)}
                    >
                      <CommunityImg
                        role="presentation"
                        src={blog.node?.featureImage.file.url} alt={blog.node.title} />
                      <span>
                        {blog.node.title}
                      </span>
                    </div>)
              })
            }

          </div>
          <div className="column3">
            {
              (column3 || []).map((blog, idx) => {
                return <div key={`blog-${idx}`}
                  className="noissue__industry-experts__reel-section__blogs__item"
                  onKeyDown={() => openNewBlog(blog)}
                  onClick={() => openNewBlog(blog)}
                >
                  <CommunityImg
                    role="presentation"
                    src={blog.node?.featureImage.file.url} alt={blog.node.title} />
                  <span>
                    {blog.node.title}
                  </span>
                </div>
              })
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IndustryExpertsBlogModal;